<template>
  <container-two-column class="login-form">
    <!-- LOGIN STEP -->
    <template v-slot:main>
      <box-login
        v-if="['step-1', 'step-2', 'change-password-step', 'otp-step'].includes(currentStep)"
      >
        <!-- Step1 Login email -->
        <login
          v-show="currentStep === 'step-1'"
          :email="email"
          :password="password"
          :count="focusInputCount"
          @updateEmail="handleUpdateEmail"
          @updatePassword="handleUpdatePassword"
          @goToStep="handleStep"
        />
        <!-- End step-1 Login email -->
        <!-- Step2 Login password -->
        <login-challenge
          v-show="currentStep === 'step-2'"
          :email="email"
          :password="password"
          @updateEmail="handleUpdateEmail"
          @updatePassword="handleUpdatePassword"
          @updateVerifiedPhone="handleUpdateVerifiedPhone"
          :count="focusInputCount"
          @goToStep="handleStep"
          @updateMessage="handleExpireMessage"
        />
        <!-- End step-2 Login password -->
        <!-- Step change expired password -->
        <change-password-expire
          v-if="currentStep === 'change-password-step'"
          :password="password"
          :count="focusInputCount"
          @goToStep="handleStep"
          :errorMessage="changePasswordExpireMessage"
          @updateMessage="handleExpireMessage"
        />
        <!-- End Step change expired password -->
        <!-- Step otp login -->
        <login-otp
          v-else-if="currentStep === 'otp-step'"
          :email="email"
          :verified-phone="verifiedPhone"
          :count="focusInputCount"
          @goToStep="handleStep"
        />
        <!-- End step otp login -->
      </box-login>
      <change-expired-password-successful v-else-if="currentStep === 'change-success-step'"/>
    </template>
    <!-- END LOGIN STEP -->

    <!-- FOOTER ADS -->
    <template v-slot:footer>
      <footer-ads
        v-if="isShowFooterAds"
        :is-loading="isLoadingBanners"
        :data="footerAdsData"
      />
    </template>
    <!-- END FOOTER ADS -->
  </container-two-column>
</template>

<script>
import { mapGetters } from 'vuex';
import ContainerTwoColumn from '@/components/commons/ContainerTwoColumn.vue';
import bannerServices from '@/services/banners';
import FooterAds from '@/components/commons/FooterAds.vue';
import Login from '@/views/Login/Login.vue';
import LoginChallenge from '@/views/Login/LoginChallenge.vue';
import ChangePasswordExpire from '@/views/Login/ChangePasswordExpire.vue';
import LoginOtp from '@/views/Login/LoginOtp.vue';
import BoxLogin from '@/components/commons/BoxLogin.vue';
import ChangeExpiredPasswordSuccessful from '@/views/Login/ChangeExpiredPasswordSuccessful.vue';
import { DASHBOARD } from '@/config/urls';
import { addSearchParams } from '@/utils/common';

export default {
  name: 'LoginIndex',
  components: {
    ContainerTwoColumn,
    FooterAds,
    Login,
    LoginChallenge,
    LoginOtp,
    ChangePasswordExpire,
    ChangeExpiredPasswordSuccessful,
    BoxLogin,
  },
  data() {
    return {
      dashboardUrl: DASHBOARD,
      isLoadingBanners: false,
      footerAdsData: [],
      currentStep: 'step-1',
      email: '',
      password: '',
      focusInputCount: 0,
      verifiedPhone: false,
      changePasswordExpireMessage: '',
    };
  },
  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
    ...mapGetters('auth', ['callbackUrl', 'ticket', 'twebmail']),
    isShowFooterAds() {
      return ['step-1', 'otp-step'].includes(this.currentStep);
    },
  },
  beforeMount() {
    this.getInfoBanners();
    this.$watch(
      '$i18n.locale',
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        this.getInfoBanners();
      },
    );
  },
  methods: {
    async getInfoBanners() {
      try {
        this.isLoadingBanners = true;
        const res = await bannerServices.getBanners();
        this.isLoadingBanners = false;
        this.footerAdsData = res?.footer ?? [];
      } catch (error) {
        this.isLoadingBanners = false;
      }
    },
    handleStep(step = 'step-1') {
      if (step === 'final-step') {
        const urlRedirect = this.callbackUrl || this.dashboardUrl;
        let nextUrl = addSearchParams(urlRedirect, { ticket: this.ticket });
        nextUrl = this.twebmail
        ? addSearchParams(nextUrl, { login_param: this.twebmail })
        : nextUrl;
        window.location.href = nextUrl.href;
      } else {
        this.currentStep = step;
        this.focusInputCount = new Date().getTime();
      }
    },
    handleUpdateEmail(email) {
      this.email = email;
    },
    handleUpdatePassword(password) {
      this.password = password;
    },
    handleUpdateVerifiedPhone(verifiedPhone) {
      this.verifiedPhone = verifiedPhone;
    },
    handleExpireMessage(msg = '') {
      if (msg && msg !== this.changePasswordExpireMessage) {
        this.changePasswordExpireMessage = msg;
      }
    },
  },
};
</script>
